var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMatch = function SvgIconMatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-match_svg__a)",
    stroke: "#212121",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.34 40c8.472 0 15.34-6.868 15.34-15.34S27.812 9.32 19.34 9.32 4 16.188 4 24.66 10.868 40 19.34 40Z",
    fill: "#006DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.34 35.15c5.793 0 10.49-4.697 10.49-10.49 0-5.794-4.697-10.49-10.49-10.49-5.794 0-10.49 4.696-10.49 10.49 0 5.793 4.696 10.49 10.49 10.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.34 28.7a4.04 4.04 0 1 0 0-8.08 4.04 4.04 0 0 0 0 8.08Z",
    fill: "#006DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.58 24.42 36.14 7.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.19 4-3.84 3.84.96 3.85 3.85-3.85L35.19 4ZM40 8.81l-3.84 3.84-3.85-.96 3.85-3.85 3.84.97Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-match_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h44v44H0z"
  })))));
};
export default SvgIconMatch;